export default "__VITE_ASSET__C$getk_X__"